import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import classNames from 'classnames';

import styles from './schedule-box.css';

const { div, header, p } = hh(h);

const ScheduleBox = ({
    startTime,
    endTime,
    bodyText,
    theme = 'white'
}) => {
    return (
        div({className: styles.container}, [
            header({className: classNames(
                styles.header,
                R.prop(`${theme}Header`, styles)
            )}, [
                p({className: styles.time},
                  `${startTime} – ${endTime}`)]),
            p({className: styles.body}, bodyText)])
    );
};

ScheduleBox.propTypes = {
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(['white', 'two', 'seven', 'jsCourse']).isRequired
};

export default ScheduleBox;



/** WEBPACK FOOTER **
 ** ./src/ScheduleBox/index.js
 **/